import Vue from 'vue';
import VueRouter from 'vue-router';
import dev_routes from '@/router/dev_routes';
import { jwtDecode } from 'jwt-decode'
import moment from "moment/moment";

Vue.use(VueRouter);
let targetRoutes = [];
const routes = require(process.env.VUE_APP_ROUTES);
const totalRoutes = process.env.NODE_ENV === 'development'? [...dev_routes, ...routes.default] : routes.default;

for(const idx in totalRoutes) {
  const currentRoute = totalRoutes[idx];
  if(currentRoute.type === 'category' && currentRoute.subRoutes) {
    targetRoutes.push(...currentRoute.subRoutes);
  } else {
    targetRoutes.push(currentRoute);
  }
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: targetRoutes
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')

  if (to.path === '/')
    next()

  if (token && isValidToken(token)) {
    next()
  } else {
    next('/')
  }

})

function isValidToken(token) {
  const payload = jwtDecode(token);
  const cur = moment().unix()
  const exp = payload.exp

  return (moment(exp).isAfter(cur));
}

export default router;
